import ForwardEmailIcon from "@mui/icons-material/ForwardToInboxRounded";
import { Avatar, Box, Card, CardContent, Stack, Switch, Typography } from "@mui/material";

interface Props {
  enabled: boolean;
  disabled?: boolean;
  onChange: (enabled: boolean) => void;
}

const AutomaticInvitesSection = ({ enabled, disabled, onChange }: Props) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="subtitle1" sx={{ py: 2 }}>
        Automation
      </Typography>
      <Card variant="outlined">
        <CardContent>
          <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
            <Avatar variant="rounded" sx={{ width: 32, height: 32, bgcolor: "background.grey" }}>
              <ForwardEmailIcon color="action" />
            </Avatar>
            <Stack spacing={0.5} sx={{ pr: 0.5, width: "100%" }}>
              <Typography variant="subtitle2">Automatic Invitation Emails</Typography>
              <Typography color="textSecondary">
                Enable this option to automatically send invitation emails when a contact is assigned a portal role and
                there is at least one live investor document published for them.
              </Typography>
            </Stack>
            <Switch disabled={disabled} checked={enabled} onChange={(_, checked) => onChange(checked)} />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AutomaticInvitesSection;
